module.exports = __webpack_public_path__ + "static/second-94e411c179d9b490a60eab0beab167c2.svg";